import { isDefaultRovoChat } from '@atlassian/conversation-assistant-utils/default-agent';

/**
 * @private
 * @deprecated Use `isDefaultRovoChat` from
 * `@atlassian/conversation-assistant-utils/default-agent` and invert the result.
 */
export const isRovoCustomAgent = (agentId: string | null | undefined): boolean => {
	if (!agentId) {
		return false;
	}

	return !isDefaultRovoChat({ agentId, agentNamedId: agentId });
};
